import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let AccordionComp;

class Accordion extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: AccordionComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(import(
      /* webpackChunkName: "components/javascript/zcat-components/accordion-comp" */
      "../../../components/javascript/zcat-components/accordion-comp"
    ).then(function(res) {
      AccordionComp = res.AccordionComp;
    }));

    
;
  }
}

export { Accordion };
